import '../../d3-interpolate/dist/d3-interpolate.js';
import { exports as d3InterpolateExports } from '../../../_virtual/d3-interpolate.js';
var ramp = scheme => d3InterpolateExports.interpolateRgbBasis(scheme[scheme.length - 1]);
export { ramp as default };
//# sourceMappingURL=ramp.js.map
